const experience = [
  {
    company: "Stripe",
    logo: "/assets/logos/stripe.png",
    date: "Feb 2026 - Present",
    role: "Software Engineer",
    description:
      "LPM Partner Success Team"
  },
  {
    company: "Routerr Health",
    logo: "/assets/logos/routerr.png",
    date: "May 2025 - Sep 2025",
    role: "Software Engineering Intern",
    description:
      "Built a clinical route optimization and scheduling algorithm for hospital-at-home programs, leveraging constraint programming, traffic modeling, and a custom Excel UI. Project awarded the Columbia Engineering Ignition Grant."
  },
  {
    company: "Citi",
    logo: "/assets/logos/citi.png",
    date: "Jun 2023 - Aug 2023",
    role: "ICG Technology Summer Analyst",
    description:
      "Analyzed 600,000 Citi Bike trips with Tableau and Python, identifying geographic and seasonal trends to optimize station placement and bike redistribution. Developed a dashboard to monitor data anomalies during a system migration for 1,000+ users."
  },
  {
    company: "Verint",
    logo: "/assets/logos/verint.png",
    date: "Feb 2023 - Apr 2023",
    role: "Software Engineering Intern",
    description:
      "Architected a microservice using Spring Boot, Apache Kafka, and PostgreSQL to efficiently retrieve and store 100,000+ cloud recording metadata entries. Executed unit and integration testing with 95% coverage to ensure system reliability."
  }
];

export default experience;
